import { render, staticRenderFns } from "./PrijavaForma.vue?vue&type=template&id=f23576bc&scoped=true&"
import script from "./PrijavaForma.vue?vue&type=script&lang=js&"
export * from "./PrijavaForma.vue?vue&type=script&lang=js&"
import style0 from "./PrijavaForma.vue?vue&type=style&index=0&id=f23576bc&scoped=true&lang=css&"
import style1 from "./PrijavaForma.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23576bc",
  null
  
)

export default component.exports